export default {
  bind(el, { value }) {
    el.clickOutsideEvent = function (event) {
      if (!$(event.target).parents(value.focus).length && $(value.focus).is(':visible')) {
        value.binding();
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};